import { render, staticRenderFns } from "./grossing-touch-media-card.vue?vue&type=template&id=a50b242e&scoped=true&"
import script from "./grossing-touch-media-card.ts?vue&type=script&lang=ts&"
export * from "./grossing-touch-media-card.ts?vue&type=script&lang=ts&"
import style0 from "./grossing-touch-media-card.scss?vue&type=style&index=0&id=a50b242e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50b242e",
  null
  
)

export default component.exports